export default __webpack_public_path__ + "static/media/placeholder_business02-fr-mobile.1d23874f.png";